import React from 'react';
import Button from './Button';
import Icon from '../AppIcon';

const ServiceErrorAlert = ({ 
  error, 
  onDismiss, 
  onRetry, 
  supportActions = [], 
  showSupport = true,
  fallback = null 
}) => {
  const getSeverityColor = (error) => {
    if (error?.includes('Authentication') || error?.includes('auth')) {
      return 'text-warning';
    }
    if (error?.includes('network') || error?.includes('connection')) {
      return 'text-info';
    }
    return 'text-destructive';
  };

  return (
    <div className="mt-6 p-4 bg-destructive/10 border border-destructive/20 rounded-lg">
      <div className="flex items-start space-x-3">
        <Icon 
          name="AlertCircle" 
          size={20} 
          color="var(--color-destructive)" 
          strokeWidth={2} 
          className="mt-0.5" 
        />
        <div className="flex-1">
          <h4 className={`text-sm font-semibold ${getSeverityColor(error)} mb-1`}>
            Registration Error
          </h4>
          <p className={`text-sm ${getSeverityColor(error)} mb-3`}>
            {error}
          </p>
          
          {fallback && (
            <div className="mb-3 p-2 bg-warning/10 border border-warning/20 rounded text-sm text-warning">
              <strong>Good News:</strong> {fallback}
            </div>
          )}
          
          {supportActions?.length > 0 && (
            <div className="mb-3">
              <p className="text-sm font-medium text-foreground mb-2">Try these steps:</p>
              <ul className="text-sm text-text-secondary space-y-1 list-disc list-inside">
                {supportActions?.map((action, index) => (
                  <li key={index}>{action}</li>
                ))}
              </ul>
            </div>
          )}
          
          <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3">
            {onRetry && (
              <Button
                variant="outline"
                size="sm"
                onClick={onRetry}
                iconName="RefreshCw"
                iconPosition="left"
              >
                Try Again
              </Button>
            )}
            <Button
              variant="outline"
              size="sm"
              onClick={() => window.location?.reload()}
              iconName="RefreshCw"
              iconPosition="left"
            >
              Refresh Page
            </Button>
            {onDismiss && (
              <Button
                variant="outline"
                size="sm"
                onClick={onDismiss}
                iconName="X"
                iconPosition="left"
              >
                Dismiss
              </Button>
            )}
            {showSupport && (
              <Button
                variant="outline"
                size="sm"
                onClick={() => window.open('mailto:support@solvarsity.com', '_blank')}
                iconName="Mail"
                iconPosition="left"
              >
                Contact Support
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceErrorAlert;